import { BrandHeader } from '../../components/BrandHeader';
import { DesktopOnly, MobileOnly } from '../../components/Layout';
import { SideImage } from '../../components/SideImage';
import { SignInForm } from '../../composites/SignInModal';
import { SplitLayout } from '../../composites/SplitLayout';
import { layout } from '../../theme/tokens';
import { ContentColumn, FormArea, FormPanel, SuccessMessage } from './SignInTemplate.styles';
import type { SignInTemplateProps } from './SignInTemplate.types';

export function SignInTemplate({
  propertyName,
  propertyLogoUrl,
  heroImageUrl,
  imageAlt = '',
  signUpSuccessMessage,
  ...formProps
}: SignInTemplateProps) {
  const brandHeader = <BrandHeader propertyName={propertyName} logoUrl={propertyLogoUrl} />;

  return (
    <>
      <MobileOnly>{brandHeader}</MobileOnly>
      <SplitLayout
        leftWidth="45%"
        height="100vh"
        left={
          <SideImage
            src={heroImageUrl}
            alt={imageAlt}
            sticky
            mobileHeight={layout.heroImageMobileHeight}
          />
        }
        right={
          <ContentColumn>
            <DesktopOnly>{brandHeader}</DesktopOnly>
            <FormArea>
              {signUpSuccessMessage ? (
                <SuccessMessage role="status">{signUpSuccessMessage}</SuccessMessage>
              ) : (
                <FormPanel>
                  <SignInForm {...formProps} insetLabels />
                </FormPanel>
              )}
            </FormArea>
          </ContentColumn>
        }
      />
    </>
  );
}
